export const NotFoundPage = () => {
  return (
    <div>
      <p>さがしたページがそんざいしません!</p>
    </div>
  );
};
